import { FC, useEffect, useState } from 'react'
import EmptyStateImage from 'assets/images/empty-state-image.svg'
import EmptyStateImageEn from 'assets/images/empty-state-image-en.svg'
import { StyledImage, StyledLobbyContainer } from './style'
import { useSelector } from 'react-redux'
import { RootState } from 'store/store'
import { ELanguage } from 'types/enums/ELanguage'

const EmptyState: FC = () => {
  const languageCode = useSelector(
    (state: RootState) => state.layout.language.code,
  )
  const [emptyStateImage, setEmptyStateImage] = useState(EmptyStateImage)

  useEffect(() => {
    switch (languageCode) {
      case ELanguage.ENGLISH:
        setEmptyStateImage(EmptyStateImageEn)
        break
      default:
        setEmptyStateImage(EmptyStateImage)
    }
  }, [languageCode])

  return (
    <StyledLobbyContainer>
      <StyledImage src={emptyStateImage} />
    </StyledLobbyContainer>
  )
}

export default EmptyState
